export default "__VITE_ASSET__BnLwjpUm__"